import { render, staticRenderFns } from "./login-popup.vue?vue&type=template&id=af68a68a&scoped=true&"
import script from "./login-popup.vue?vue&type=script&lang=js&"
export * from "./login-popup.vue?vue&type=script&lang=js&"
import style0 from "./login-popup.vue?vue&type=style&index=0&id=af68a68a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af68a68a",
  null
  
)

export default component.exports